document.addEventListener('DOMContentLoaded', () => {
  // Collapse focus behavior; used primarily for meganav

  // Selector for getting tab-focusable elements
  const focusableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
    'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
    'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';


  // When collapse is expanded and Escape key is pressed, focus on the toggle element and close the collapse
  function setToggleEscape(event, toggleElement) {
    if (event.key == 'Escape' && toggleElement.matches('[aria-expanded="true"]')) {
      toggleElement.focus();
      toggleElement.click();
      event.preventDefault();
    }
  }

  // Set focus to the specified element on Shift + Tab key
  function setFocusPrevious(event, focusElement) {
    if (event.shiftKey && event.key === 'Tab') {
      if (!isHidden(focusElement)) {
        focusElement.focus();
        event.preventDefault();
      }
    }
  }

  // Set focus to the specified element on Tab key
  function setFocusNext(event, focusElement) {
    if (!event.shiftKey && event.key === 'Tab') {
      if (!isHidden(focusElement)) {
        focusElement.focus();
        event.preventDefault();
      }
    }
  }

  // borrowed from jQuery
  function isHidden(elem) {
    let width = elem.offsetWidth,
        height = elem.offsetHeight;

    return ( width === 0 && height === 0 ) ||
           ((elem.style && elem.style.display) || window.getComputedStyle(elem, 'display')) === 'none';
  }

  // watch elements for changes to the aria-hidden attribute, and fire a custom event based on the attribute value
  function watchAriaHidden(mutationsList, observer) {
    mutationsList.forEach((mutation) => {
      if (mutation.attributeName == 'aria-hidden') {
        mutation.target.dispatchEvent(new Event(mutation.target.getAttribute('aria-hidden') == 'true' ? 'wf.hidden' : 'wf.shown'));
      }
    })
  }
  let observer = new MutationObserver(watchAriaHidden);

  // When collapse toggle element with [data-collapse-toggle-focus-trap="#target"] is focused, trap tab focus within the collapse toggle and in the collapse target element
  // Pressing escape when the collapse is expanded will activate the collapse toggle
  document.querySelectorAll('[data-collapse-toggle-focus-trap="true"]').forEach((elem) => {
    let toggleElement = elem;
    let trapElement = document.querySelector(elem.getAttribute('data-wf-target'));
    let focusableTrapElements = trapElement.querySelectorAll(focusableSelector);
    let firstTrapped  = focusableTrapElements.item(0);
    let lastTrapped = focusableTrapElements.item(focusableTrapElements.length - 1);

    toggleElement.addEventListener('keydown', function(event) { setToggleEscape(event, toggleElement) } );
    focusableTrapElements.forEach((trapElem) => {
      trapElem.addEventListener('keydown', function(event) { setToggleEscape(event, toggleElement) } );
    });
    toggleElement.addEventListener('keydown', function(event) { setFocusNext(event, focusableTrapElements.item(0)) });
    toggleElement.addEventListener('keydown', function(event) { setFocusPrevious(event, lastTrapped)})
    firstTrapped?.addEventListener('keydown', function(event) { setFocusPrevious(event, toggleElement) });
    lastTrapped?.addEventListener('keydown', function(event) { setFocusNext(event, toggleElement) });
  });

  // When collapse element with [data-collapse-focus-first-on-show="true"] is shown, focus on its first focusable element
  document.querySelectorAll('[data-collapse-focus-first-on-show="true"]').forEach((elem) => {
    observer.observe(elem, { attributes: true });

    elem.addEventListener('wf.shown', function() {
      elem.querySelector(focusableSelector).focus();
    });
  });
});
